import { debounce } from 'lodash';
export var handleError = debounce(function (error) {
    if (error.status === 401) {
        var path = '/springboard/applicationAuth.html';
        if (location.href.includes(':9999')) {
            path = '/applicationAuth.html';
        }
        location.replace(path);
    }
}, 1000);
